import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b633eea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5b633eea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b633eea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b633eea')) {
      api.createRecord('5b633eea', component.options)
    } else {
      api.reload('5b633eea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b633eea&scoped=true", function () {
      api.rerender('5b633eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjPage/index.vue"
export default component.exports